import * as React from "react";
const SpectacleBOW: React.FC<any> = props => {
  return (
    <div className="splashFull">
      <a rel="dofollow" href="#home">
        <img
          src="/images/logo.svg"
          className="splashLogo"
          alt="Teatr Horzycy Logo"
        />
      </a>
      <p>
        W sprawie rezerwacji lub zakupu biletów prosimy o kontakt z Biurem Obsługi 
        Widzów tel.: 56 622 55 97, 654 90 74 lub kasą biletową tel.:56 622 30 70.
      </p>
    </div>
  );
};

export default SpectacleBOW;
